import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const STATUS_COLOR: Record<string, 'default' | 'success' | 'warning' | 'error'> = {
  Pending: 'warning',
  Approved: 'success',
  ApprovedOnce: 'success',
  ApprovedAddedToCatalogue: 'success',
  Rejected: 'error',
  MoreInfoRequested: 'warning',
  Open: 'warning',
  Resolved: 'success',
  Ignored: 'default',
  Blocked: 'error',
  Unblocked: 'success',
  Unavailable: 'error',
  Discontinued: 'error',
  LimitedStock: 'warning',
};

/** Generic status chip shared across Catalogue Governance tabs. Falls back to a neutral
 * chip for any status string not in the color map. */
const ApprovalStatusChip = ({ status, label }: { status: string; label?: string }) => {
  const { t } = useTranslation('catalogueGovernance');
  return (
    <Chip
      label={label ?? t(`chips.status.${status}`, status)}
      size="small"
      color={STATUS_COLOR[status] ?? 'default'}
      variant="outlined"
    />
  );
};

export default ApprovalStatusChip;
